import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { responseGroupSx, responseBtnSx } from '../styles';

const ResponseButtons = ({
  options = [],
  selectedValue,
  onChange,
  vertical = false,
}) => (
    <Box sx={responseGroupSx(vertical)}>
      {options.map((option) => {
        const isSelected = selectedValue === option.value;

        return (
          <Box
            key={option.value}
            onClick={() => onChange?.(option.value)}
            sx={responseBtnSx(option.variant || 'default', isSelected)}
          >
            {option.icon && (
              <Box className="icon">
                {option.icon}
              </Box>
            )}
            <Box className="text">
              <Typography component="span">{option.label}</Typography>
              {option.subtitle && (
                <Typography component="small">{option.subtitle}</Typography>
              )}
            </Box>
          </Box>
        );
      })}
    </Box>
  );

ResponseButtons.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      subtitle: PropTypes.string,
      variant: PropTypes.oneOf(['positive', 'negative', 'danger', 'default']),
      icon: PropTypes.node,
    })
  ),
  selectedValue: PropTypes.string,
  onChange: PropTypes.func,
  vertical: PropTypes.bool,
};

export default ResponseButtons;
